module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 19.5v3h12v-3H10zm6-2l-6-8h12l-6 8z\"></path></svg>"